import { useMutation } from "@tanstack/vue-query";
import type { MutationResponseOptions } from "../../mutationResponseTypes";
import { useGqlPopulateUserPatrimonialData } from "~/graphql/repo";
import type {
  PopulateUserPatrimonialDataMutation,
  PopulateUserPatrimonialDataMutationVariables,
} from "~/graphql/generated/graphql";

export const useUpdateUserPatrimonialData = (
  options?: MutationResponseOptions,
) => {
  const populateUserPatrimonialData = useGqlPopulateUserPatrimonialData();

  return useMutation<
    PopulateUserPatrimonialDataMutation,
    Error,
    PopulateUserPatrimonialDataMutationVariables
  >({
    mutationFn: (variables) => {
      return populateUserPatrimonialData(variables);
    },
    onSuccess: (result) => options?.onSuccess?.({ response: result }),
    onError: (error) => options?.onError?.(error),
  });
};
